/** Format USD amount stored as micros (1 USD = 1_000_000 micros). */
export function formatUsdMicros(micros, decimals = 4) {
    if (micros == null || !Number.isFinite(micros))
        return "—";
    return `$${(micros / 1_000_000).toFixed(decimals)}`;
}
/** Legacy millicents (1 millicent = 0.00001 USD). */
export function formatCostMillicents(mc, decimals = 4) {
    if (mc == null || !Number.isFinite(mc))
        return "—";
    return `$${(mc / 100_000).toFixed(decimals)}`;
}
